import PlotlyStockChart from "../../../charts/Plotly/PlotlyStockChart";
import React, {useState } from "react";
import {Space, Typography, Card, Divider} from "antd";
import Button from "@mui/material/Button";


const ChartSelector = ({timeseriesData, onSubmit})=>{
    const [selectedDates, setSelectedDates] = useState([]);

    const handleDateSelect = (date)=>{
        if (!selectedDates.includes(date)){
            setSelectedDates([...selectedDates, date]);
        }
    }
    const handleRemoveDate = (date)=>{
        setSelectedDates(selectedDates.filter(d=>d!==date));
    }
    const handleResetDates = ()=>{
        setSelectedDates([]);
    }

    return (
        <Card bordered={false}>
            <Space className={''}>
            </Space>
            <div className={'p-2'} style={{width: '100%', maxWidth: 1200, height: 600}}>
                <PlotlyStockChart
                      timeseriesData={timeseriesData}
                      onDateSelected={handleDateSelect}
                      onDateRemoved={handleRemoveDate}
                      description={'Select Dates by clicking on the chart below. The dates selected will be used in the explanation of the portfolio and its changes'}
                      callbackOnClearAnnotations={handleResetDates}
                      extra={<Button onClick={()=>onSubmit(selectedDates)} variant={'contained'} color={'info'}>Continue</Button>}
                      currentRange={selectedDates?.length > 0 ? selectedDates : null}
                  />
            </div>
        </Card>
    )
}

export default ChartSelector;